import { useCallback, useMemo, useState } from "react";
import { ChevronLeft } from "lucide-react";
import ModalComponent from "@/components/ui/ModalComponent";
import Button from "../../ui/button";
import { useInstallmentPaymentGatewaysContext } from "@core/helpers/client/contexts/InstallmentPaymentGatewaysContext";
import { useAuthContext } from "@core/helpers/client/contexts/AuthContext";
import PriceComponent from "@/components/ui/Price";


export const Gateway = ({ products, page_type = "product", calculate_payment_price }) => {
    const [isInstallmentModalOpen, setIsInstallmentModalOpen] = useState(false);
    const { installment_payment_gateways } = useInstallmentPaymentGatewaysContext();
    const { cart } = useAuthContext();

    const INSTALLMENT_GATEWAY_INFO = {
        CPG_DIGI_PAY: {
            title: "دیجی‌پی",
            image: "/images/payment-gateways/digipay.png",
            description: "پرداخت اقساطی این خرید از طریق درگاه دیجی‌پی امکان‌پذیره؛ کافیه در مراحل پرداخت این روش رو انتخاب کنی.",
        },
        CPG_TOROB_PAY: {
            title: "ترب‌پی",
            image: "/images/payment-gateways/torobpay.png",
            description: "پرداخت اقساطی این خرید از طریق درگاه ترب‌پی امکان‌پذیره؛ کافیه در مراحل پرداخت این روش رو انتخاب کنی.",
        },
        CPG_SNAPP_PAY: {
            title: "اسنپ‌پی",
            image: "/images/payment-gateways/snappay.png",
            description: "پرداخت اقساطی این خرید از طریق درگاه اسنپ‌پی امکان‌پذیره؛ کافیه در مراحل پرداخت این روش رو انتخاب کنی.",
        },
    };


    const calculate_commission_price = useCallback((gateway) => {
        if (gateway?.commission_percent > 0) {
            let price;
            if (page_type === "cart") {
                price = cart?.products?.reduce((a, b) => a + (b?.count * b?.product?.mix_variant?.[0]?.price?.main_price), 0)
            } else if (page_type === "product") {
                price = products?.reduce((a, b) => a + (b?.count * b?.price), 0)
            } else if (page_type === "checkout") {
                price = calculate_payment_price;
            }
            return price + (price * (gateway?.commission_percent / 100));
        }
        return null;
    }, [products, page_type, cart?.products, calculate_payment_price])

    return (installment_payment_gateways?.length > 0 ?
        <>
            <div className="cursor-pointer" onClick={() => setIsInstallmentModalOpen(true)}>
                <div className="pt-2 mt-2 border-t border-jmt-neutral-200">
                    <div
                        className="w-full flex items-center justify-between cursor-pointer"
                    >
                        <div className="flex items-center gap-1 text-jmt-neutral-700 text-xs font-bold">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16 2V6M21 11V6C21 5.46957 20.7893 4.96086 20.4142 4.58579C20.0391 4.21071 19.5304 4 19 4H5C4.46957 4 3.96086 4.21071 3.58579 4.58579C3.21071 4.96086 3 5.46957 3 6V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H6M3 10H21M8 2V6" stroke="#171717" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M9 16.8571H21M10.2 14H19.8C20.4627 14 21 14.5117 21 15.1429V20.8571C21 21.4883 20.4627 22 19.8 22H10.2C9.53726 22 9 21.4883 9 20.8571V15.1429C9 14.5117 9.53726 14 10.2 14Z" stroke="#171717" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <span className="font-bold text-xs text-jmt-neutral-700">امکان خرید اقساطی</span>
                        </div>
                        <ChevronLeft size={16} className="text-jmt-neutral-700" />
                    </div>
                </div>


                {/* installment item */}
                <ul className="pr-2 pt-2 space-y-2">
                    {installment_payment_gateways?.map((gateway) => {

                        return (
                            <li key={gateway?.gateway} className="flex items-center gap-2 text-xs text-jmt-neutral-500">
                                <span className="w-1.5 h-1.5 rounded-full bg-jmt-neutral-700 shrink-0" />
                                <div className="flex items-center gap-2">
                                    {/* جعبه‌ی لوگو همان ۲۴×۲۴ باقی می‌ماند (فضای بیشتری نمی‌گیرد)
                                        ولی خود تصویر با نسبت اصلی خودش داخل آن جا می‌شود؛
                                        قبلا همه‌ی لوگوها به زور در ۱۳×۲۰ کشیده می‌شدند و
                                        لوگوهای عریض (ترب‌پی و اسنپ‌پی) جمع‌شده دیده می‌شدند. */}
                                    <div className="w-6 h-6 flex items-center justify-center shrink-0">
                                        {INSTALLMENT_GATEWAY_INFO[gateway?.gateway]?.image ? (
                                            <img
                                                src={INSTALLMENT_GATEWAY_INFO[gateway?.gateway].image}
                                                alt=""
                                                className="max-w-6 max-h-5 w-auto h-auto object-contain"
                                            />
                                        ) : null}
                                    </div>
                                    <span>
                                        <span>خرید اقساطی با </span>
                                        <span className="font-bold">
                                            {gateway?.gateway === "CPG_DIGI_PAY" ? ("دیجی‌پی")
                                                : gateway?.gateway === "CPG_TOROB_PAY" ? ("ترپ‌پی")
                                                    : gateway?.gateway === "CPG_SNAPP_PAY" ? ("اسنپ‌پی")
                                                        : ""}
                                        </span>
                                    </span>

                                </div>
                            </li>
                        )

                    })}

                </ul>
            </div>
            <ModalComponent
                isOpen={isInstallmentModalOpen}
                onClose={() => setIsInstallmentModalOpen(false)}
                title="روش‌های خرید اقساطی"
                size="sm"
                partialHeight={400}
                footer={
                    <Button
                        text="فهمیدم "
                        color_type="primary"
                        variant="containd"
                        className="w-full"
                        onClick={() => setIsInstallmentModalOpen(false)}
                    />
                }
            >
                <ul className="space-y-4 overflow-y-auto max-h-[400px]">
                    {installment_payment_gateways?.map((gateway) => {

                        const info = INSTALLMENT_GATEWAY_INFO[gateway?.gateway];
                        if (!info) return null;

                        return (
                            <li key={gateway?.gateway} className="flex items-start gap-3">
                                <img src={info.image} alt={info.title} className="w-6 h-6 object-contain" />
                                <div>
                                    <h4 className="font-bold text-sm text-jmt-main mb-1">{info.title}</h4>
                                    <p className="text-[13px] text-jmt-neutral-600 leading-6">{info.description}</p>
                                    {calculate_commission_price(gateway) > 0 &&
                                        <p className="text-[13px] text-jmt-neutral-600 leading-6">مبلغ نهایی با احتساب کارمزد:
                                            {" "}
                                            <PriceComponent
                                                price={calculate_commission_price(gateway)}
                                                className="font-bold"
                                            /></p>}
                                </div>
                            </li>
                        );

                    })}
                </ul>
            </ModalComponent>
        </>

        : <></>
    );
}

export default Gateway;